import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ReferenceInput,
  TextInput,
  usePermissions,
} from "react-admin";

const userFilters = [
  <TextInput source="_q" label="Search" alwaysOn variant="outlined" />,
  <ReferenceInput source="name" label="User" reference="users" />,
];

export const UserList = () => {
  const permissions = usePermissions();

  return (
    <List filters={userFilters}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="username" />
        <TextField source="email" />
        <TextField source="role.name" />
        {permissions.permissions === "Admin" ? <EditButton /> : ""}
      </Datagrid>
    </List>
  );
};
